import * as React from "react";

// NPM
import { animated } from "react-spring";

// MUI
import {
	withStyles,
	WithStyles,
	createStyles,
	Theme,
} from "@material-ui/core/styles";
import { Grid, Typography, Button } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import CallRoundedIcon from "@material-ui/icons/CallRounded";

// Utility
import Utility from "../domain/classes/Utility";

// Components
import StyledSectionContainer from "../components/common/SectionContainer.Component";
import CreditCard from "../components/creditCard/CreditCard.Component";
import AppointmentDetails from "../components/common/AppointmentDetails.Component";

// Contexts
import { useApplicationManager } from "../contexts/ApplicationManager.Context";
import { usePaymentManager } from "../contexts/PaymentManager.Context";

// Config
import { QV_MEDICAL_PHONE_NUMBER } from "../domain/utility/config";
import { MissingSignatureErrorMessage } from "../domain/classes/errors/MissingSignatureError";

export const styles = (theme: Theme) =>
	createStyles({
		root: {},
	});

export interface PrepaymentSectionProps {}

const PrepaymentSection = React.forwardRef<
	HTMLDivElement,
	PrepaymentSectionProps & WithStyles<typeof styles>
>(({ classes }, ref) => {
	const { selectedApptType } = useApplicationManager();
	const { error } = usePaymentManager();

	return (
		<StyledSectionContainer
			ref={ref}
			className={classes.root}
			maxWidth="xs"
		>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<AppointmentDetails />
				</Grid>
				<Grid item xs={12}>
					<Typography align="center" variant="body1" component="p">
						This appointment requires prepayment of
					</Typography>
				</Grid>
				<Grid item xs={12}>
					<Typography
						align="center"
						variant="h1"
						component="h1"
						color="primary"
					>
						<strong>
							${selectedApptType.preDepositAmount.toFixed(2)}
						</strong>
					</Typography>
				</Grid>
				<Grid item xs={12}>
					<CreditCard flippable />
				</Grid>
				{error && (
					<React.Fragment>
						<Grid item xs={12}>
							<Alert
								severity="error"
								action={
									error ===
									MissingSignatureErrorMessage ? undefined : (
										<Button
											onClick={() => {
												window.open(
													`tel:${QV_MEDICAL_PHONE_NUMBER}`
												);
											}}
											size="small"
											color="inherit"
											startIcon={<CallRoundedIcon />}
										>
											Call
										</Button>
									)
								}
							>
								{error}
							</Alert>
						</Grid>
					</React.Fragment>
				)}
			</Grid>
		</StyledSectionContainer>
	);
});

const StyledPrepaymentSection = withStyles(styles, {
	classNamePrefix: Utility.generateClassName("PrepaymentSection"),
})(PrepaymentSection);

export default StyledPrepaymentSection;

export const AnimatedPrepaymentSection = animated(StyledPrepaymentSection);
